import { render, staticRenderFns } from "./CountryWiseDeparturePurposeViewReport.vue?vue&type=template&id=98f0fbf8&"
import script from "./CountryWiseDeparturePurposeViewReport.vue?vue&type=script&lang=js&"
export * from "./CountryWiseDeparturePurposeViewReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports